import { ChangeEvent } from 'react';

export function createSyntheticChangeEvent(
  name: string,
  value: string,
): ChangeEvent<HTMLInputElement> {
  return {
    target: {
      name,
      value,
    },
  } as ChangeEvent<HTMLInputElement>;
}

export default createSyntheticChangeEvent;
